import React from 'react';

import { GetNormDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';

import { NormBinLink } from './NormBinLink';

interface NormsProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onClick: (id: string) => void;
  refresh: boolean;
}

export const normForGrid = (norm: GetNormDto, setRefresh?: () => void) => {
  return {
    key: norm.id,
    values: {
      'norm.name': norm.name,
      //'norm.condition': norm.condition,
      //'norm.group': norm.group,
      'indicator_test.name': norm.indicatorTest?.name,
      'test.name': norm.indicatorTest?.test?.name,
      'norm.isDefault': norm.isDefault ? 'Tak' : '',
      'norm.printText': norm.printText,
      bin: norm.id ? (
        <NormBinLink normId={norm.id} setRefresh={setRefresh} />
      ) : null,
    },
  };
};

export const Norm: React.FC<NormsProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'norm.name' },
    //{ header: 'Warunek', property: 'norm.condition' },
    //{ header: 'Grupa', property: 'norm.group' },
    { header: 'Wskaźnik', property: 'indicator_test.name' },
    { header: 'Test', property: 'test.name' },
    { header: 'Drukowany automatycznie', property: 'norm.isDefault' },
    { header: 'Dodatkowy tekst do wydruku', property: 'norm.printText' },
    { header: '', property: 'bin', noSorting: true, noFilter: true },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      onRowClick={props.onClick}
      showFilter={true}
      initialOrderColumn="test.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak norm w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      showExport={true}
    />
  );
};
